import React, { useState } from 'react'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Box, Button } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { ConfigForm } from './components'

import helpers from 'helpers'

import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'
import theme from 'theme'

const DataSubjectTicketConfig = () => {
  const [openTour, setOpenTour] = useState(false)
  const [loading, setLoading] = useState(false)

  const { DEMAND_KIND_ID } = constants.questionOptionTickets
  const { DATA_SUBJECT_CONFIG_DRIVER_STEP_1 } = constants.tours.tickets

  const { response, isLoading, refresh } = useFetch(
    service.dponet.titularTickets.indexResponsibles,
    { questionOptionTicketKind: DEMAND_KIND_ID },
    [],
  )

  const answerOptionTickets = response?.data?.answerOptionTickets || []

  const { response: responseUsers, isLoading: isLoadingUsers } = useFetch(
    service.dponet.users.get,
    {
      perPage: 10000,
      minimal: true,
      active: true,
      userCompanyStatus: constants.userCompanies.ACTIVE,
    },
    [],
  )

  const users = responseUsers?.data?.users || []

  const handleOpenTour = () => {
    const where = 'Solicitação de titulares'
    const params = { action: 'tour-configuracoes-solicitacao-titulares' }

    helpers.mixpanel.track(where, 'Tour', params)
    setOpenTour(true)
  }

  return (
    <Page title="Configurações das solicitações">
      <Container maxWidth={false}>
        <ContentHeader title="Configurações das solicitações">
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            id={DATA_SUBJECT_CONFIG_DRIVER_STEP_1}
            disabled={loading}
            fullWidth
          >
            Tutorial
          </Button>
        </ContentHeader>
        <LoadingFeedback open={loading} />
        <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
          {isLoading || isLoadingUsers ? (
            <Box
              display="flex"
              flexDirection="column"
              gridGap={theme.spacing(2)}
            >
              <Skeleton variant="text" width="100%" />
              {[...Array(2)].map((_, idx) => (
                <Skeleton key={idx} variant="rect" width="100%" height={99} />
              ))}
              <Skeleton variant="rect" width="100%" height={49} />
              <Box
                display="flex"
                justifyContent="flex-end"
                gridGap={theme.spacing(1)}
              >
                {[...Array(2)].map((_, idx) => (
                  <Skeleton key={idx} variant="rect" width={85} height={37} />
                ))}
              </Box>
            </Box>
          ) : (
            <ConfigForm
              answerOptionTickets={answerOptionTickets}
              users={users}
              setLoading={setLoading}
              refresh={refresh}
              openTour={openTour}
              setOpenTour={setOpenTour}
            />
          )}
        </Box>
      </Container>
    </Page>
  )
}

export default DataSubjectTicketConfig
